import type { UpgradeMap, Upgrade, UpgradeLevel } from '../types/upgrades'

export const UPGRADES: UpgradeMap = {
  drill: {
    id: 'drill',
    name: 'Drill Speed',
    description: 'Reduces fuel cost per tile',
    baseCost: 100,
    costMultiplier: 3,
    maxLevel: 5,
    levels: [
      { fuelMultiplier: 1.0 },
      { fuelMultiplier: 0.80 },
      { fuelMultiplier: 0.60 },
      { fuelMultiplier: 0.40 },
      { fuelMultiplier: 0.22 },
      { fuelMultiplier: 0.12 },
    ],
  },
  fuelTank: {
    id: 'fuelTank',
    name: 'Fuel Tank',
    description: 'Increases max fuel capacity',
    baseCost: 75,
    costMultiplier: 3,
    maxLevel: 5,
    levels: [
      { capacity: 30 },
      { capacity: 60 },
      { capacity: 130 },
      { capacity: 300 },
      { capacity: 700 },
      { capacity: 1500 },
    ],
  },
  cargo: {
    id: 'cargo',
    name: 'Cargo Hold',
    description: 'Increases max cargo weight',
    baseCost: 100,
    costMultiplier: 3,
    maxLevel: 5,
    levels: [
      { capacity: 15 },
      { capacity: 30 },
      { capacity: 60 },
      { capacity: 120 },
      { capacity: 250 },
      { capacity: 500 },
    ],
  },
  negotiator: {
    id: 'negotiator',
    name: 'Negotiator',
    description: 'Multiplies ore sell prices',
    baseCost: 150,
    costMultiplier: 3,
    maxLevel: 5,
    levels: [
      { priceMultiplier: 1.0 },
      { priceMultiplier: 1.20 },
      { priceMultiplier: 1.45 },
      { priceMultiplier: 1.75 },
      { priceMultiplier: 2.10 },
      { priceMultiplier: 2.50 },
    ],
  },
  luck: {
    id: 'luck',
    name: 'Luck',
    description: 'Increases rare ore chance',
    baseCost: 125,
    costMultiplier: 3,
    maxLevel: 5,
    levels: [
      { rarityMultiplier: 1.0 },
      { rarityMultiplier: 1.15 },
      { rarityMultiplier: 1.35 },
      { rarityMultiplier: 1.60 },
      { rarityMultiplier: 1.90 },
      { rarityMultiplier: 2.25 },
    ],
  },
}

export function getUpgradeCost(upgrade: Upgrade<UpgradeLevel>, currentLevel: number): number {
  if (currentLevel >= upgrade.maxLevel) return Infinity
  return Math.floor(upgrade.baseCost * Math.pow(upgrade.costMultiplier, currentLevel))
}
